/* eslint-disable array-callback-return */
import "./AddproductPage.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Form, Col } from "react-bootstrap";
import upload_img from "../../../assets/upload_img.png";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import UploadfilesPage from "../../tusimageupload/components/UploadfilesPage";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  ADD_PRODUCT,
  VAT_LIST,
  LIST_UNIT,
  PRODUCT_DETAIL,
  SUBCATEGORY_LIST,
  STORE_DETAIL,
} from "../../constants/apiurl";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import information from "../../../assets/information.svg";
import close_cross from "../../../assets/close_cross.svg";
import { postRequestcall } from "../../comman/util/postRequest";
import FormgroupPage, { FormLabel } from "../../comman/formgroup/FormgroupPage";
import VariationboxPage from "../../comman/components/VariationboxPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import SingleselectPage from "../../comman/customselect/SingleselectPage";
import MultiselectPage from "../../comman/customselect/MultiselectPage";
import { fetchLogindata } from "../../login/redux/actions";
const HelpPage = React.lazy(() => import("../../modal/components/HelpPage"));
const Subcategorymanual = React.lazy(() => import("./Subcategorymanual"));
const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function AddproductPage(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.add_product.deletevariation"),
    sub_title: t("pages.add_product.variationsub_title"),
    name: "",
    id: "",
    type: "",
  });
  let getpid = window.location.pathname.split("/").pop();
  const [showAddVariation, setShowAddVariation] = useState(true);
  const errorParameter = {
    title: "",
    title_in_tr: "",
    description: "",
    description_in_tr: "",
    select_sub_category: "",
    select_category: "",
    images: "",
    select_vat: "",
  };
  const inputValue = {
    title: "",
    title_in_tr: "",
    description: "",
    description_in_tr: "",
    images: "",
    sku: "",
    service_id: "",
    sub_service_id: "",
    store_id: "",
    id: "",
  };
  const variantParameter = {
    quantity: "",
    price: "",
    stock: "",
    is_stock: "yes",
    discount: "",
  };
  const varianterror = {
    quantity: "",
    price: "",
    unit: "",
    stock: "",
  };
  const [errorMsg, setErrormsg] = useState(errorParameter);
  const [addProducts, setAddproducts] = useState(inputValue);
  // variant state
  const [addVariant, setAddvariant] = useState(variantParameter);
  const [variantlist, setVariantlist] = useState([]);
  const [errorVariant, setErrorvariant] = useState(varianterror);
  // Category
  const [categorylist, setCategorylist] = useState([]);
  const [selectcategory, setSelectcategory] = useState([]);
  // Sub category
  const [subcategorylist, setSubcategorylist] = useState([]);
  const [selectsubcategory, setSelectsubcategory] = useState([]);
  // unit list
  const [unitlist, setUnitlist] = useState([]);
  const [selectUnit, setselectUnit] = useState([]);
  const [stockhide, setStockhide] = useState(true);
  const [showsubcategory, setShowsubcategory] = useState(true);
  const [imageName, setImagename] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // vat
  const [taxarray, setTaxarray] = useState([]);
  const [selectedTax, setSelectedTax] = useState([]);
  // show sub cat manual
  const [showSubmanual, setShowsubmanual] = useState(false);
  const [showList, setShowList] = useState(false);
  var [showsubCategorylist, setShowsubcategorylist] = useState(false);
  var [showvatlist, setShowvatlist] = useState(false);
  var [showunits, setShowunits] = useState(false);
  const [position, setPosition] = useState()

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getStoreDetail())();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.add_product.deletevariation"),
      sub_title: t("pages.add_product.variationsub_title"),
    });
    // eslint-disable-next-line
  }, [props?.language]);

  const getStoreDetail = async () => {
    props?.fetchHeaderContent(t("pages.sidenav.addproduct"), "", "");
    if (getpid !== "add") {
      setShowAddVariation(false);
    }
    let geturl = STORE_DETAIL + `/${props?.storeDetail?.store_id}/no`;
    let storeDetailresponse = await getRequestcall(geturl, props?.access_token);
    if (storeDetailresponse?.status === 200) {
      let storedetail = await storeDetailresponse.json();
      let categoryObject = {};
      let updatedCategorylist = [];
      let serviceArray = storedetail?.data?.service_id?.split(",");
      /// If vendor sign up without category then check if it is null or not
      if (serviceArray[0] !== "null") {
        serviceArray.forEach((getitem) => {
          let getServices = props.categories.filter(
            (item) => item.id === getitem
          );
          if (getServices.length > 0) {
            categoryObject = {
              value: getServices[0]?.id,
              label: getServices[0]?.title,
            };
            updatedCategorylist.push(categoryObject);
          }
        });
        setCategorylist(updatedCategorylist);
        callVatlist(updatedCategorylist);
      } else {
        toast.error(
          t(
            "pages.Your store detail is incomplete please add the business category first in your setup store"
          )
        );
        setCategorylist([]);
        callVatlist([]);
      }
    } else if (storeDetailresponse?.status === 400) {
      props?.clearStoredetail([]);
      props.logindata.type = "user";
      props.fetchLogindata(props.logindata);
      let getError = await storeDetailresponse.json();
      toast.error(getError?.errors);
      navigate("/vendor/");
    }
  };

  const callVatlist = async (updatedCategorylist) => {
    let taxlist = await getRequestcall(VAT_LIST, props?.access_token);
    let taxobj = {};
    let taxarray = [];
    if (taxlist?.status === 200) {
      let getList = await taxlist.json();
      if (getList?.data?.length !== 0) {
        getList?.data?.forEach((item) => {
          taxobj = {
            label: `${item?.vatname} ${item?.vatrate} ${"%"}`,
            value: item.id,
            vatrate: item?.vatrate,
          };
          taxarray.push(taxobj);
        });
        setTaxarray(taxarray);
        if (getpid === "add") {
          let getZerovat = taxarray?.filter((item) => item?.vatrate === "0");
          if (getZerovat?.length !== 0) {
            setSelectedTax(getZerovat[0]);
          } else {
            setSelectedTax(taxarray[0]);
          }
        }
      }
    } else if (taxlist.status === 500) {
      toast.error(t("pages.internal"));
    }
    if (getpid !== "add") {
      productEdit(updatedCategorylist, taxarray);
    }
  };

  const productEdit = async (updatedCategorylist, taxarray) => {
    let url = PRODUCT_DETAIL + `/v2/${getpid}`;
    let productdetail = await getRequestcall(url, props.access_token); // get product detail for edit
    if (productdetail?.status === 200) {
      let productData = await productdetail.json();
      props?.fetchHeaderContent(productData?.data?.title, "", "");
      // Set the selected vat id at the time of edit
      let getVat = taxarray.filter(
        (item) => item.value === productData?.data?.vat_id
      );
      if (getVat?.length !== 0) {
        setSelectedTax(getVat[0]);
      } else {
        setSelectedTax(taxarray[0]);
      }
      getProductEditdata(productData?.data, updatedCategorylist);
    }
  };

  const getProductEditdata = async (getProductedit, updatedCategorylist) => {
    setAddproducts({
      ...addProducts,
      id: getProductedit?.pid,
      title: getProductedit?.title,
      title_in_tr: getProductedit?.title_in_tr,
      description: getProductedit?.description,
      description_in_tr: getProductedit?.description_in_tr,
      service_id: getProductedit?.service_id,
      sku: getProductedit?.sku,
    });
    // Filter for category
    let getSelectedCategory = updatedCategorylist.filter(
      (item) => item.value === getProductedit?.service_id
    );
    if (getSelectedCategory?.length === 0) {
      setSelectcategory([]);
    } else {
      setSelectcategory(getSelectedCategory[0]);
    }
    let subcategoryArray = [];
    subcategoryArray = getProductedit.sub_service_id?.split(",");
    callSubcategorylist(subcategoryArray, getProductedit?.service_id);
    let getImagename = [];
    let imageObject = {};
    if (getProductedit?.images !== null) {
      if (getProductedit?.images?.length > 0) {
        getProductedit.images.forEach((item) => {
          let getFilename = item.split("/").pop();
          let value = item.includes("master_product");
          if (value === true) {
            getFilename = "/" + getFilename;
          }
          imageObject = {
            preview_url: item,
            fileName: getFilename,
          };
          getImagename.push(imageObject);
        });
        setImagename(getImagename);
      }
    }
    getUnitlistforvariant(
      getProductedit?.service_id,
      getProductedit?.variations
    );
  };

  const selectCategorychange = async (e, selectCategory, index) => {
    e.preventDefault();
    setSelectcategory(selectCategory);
    setSelectsubcategory([]); // After select another category selected sub cateory should be empty
    setVariantlist([]); // After select another category varition box clear
    setShowAddVariation(true); // after list clear show variation box for add
    callSubcategorylist([], selectCategory?.value); // sub category call
    setAddproducts({
      ...addProducts,
      service_id: selectCategory?.value,
    });
    getUnitlistforvariant(selectCategory?.value, []);
    setErrormsg({
      ...errorMsg,
      select_category: "",
    });
  };

  const selectsubCategorychange = async (e, selectsubCategory, index) => {
    e.preventDefault();
    let updatedlist = [...selectsubcategory]
    updatedlist.push(selectsubCategory)
    setSelectsubcategory(updatedlist);
    setErrormsg({
      ...errorMsg,
      select_sub_category: "",
    });
    // Remove from sub category list 
    setPosition(index)
    let getList = subcategorylist?.filter((item, index) => item?.value !== selectsubCategory?.value)
    setSubcategorylist(getList);
    setShowsubcategorylist(false);
  };

  const removesubCategory = (e, getItem) => {
    e.stopPropagation();
    e.preventDefault();
    let updatedlist = [...selectsubcategory]
    updatedlist = updatedlist.filter((item) => item.value !== getItem.value);
    setSelectsubcategory(updatedlist);
    // After remove add into the list to previoues position
    let updatedCategory = [...subcategorylist];
    updatedCategory.splice(position, 0, getItem);
    setSubcategorylist(updatedCategory);
    setShowsubcategorylist(false);
  }

  const clearSelectedsubcategory = (e, getItem) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectsubcategory([]);
    // After remove add into the list to previoues position
    let updatedCategory = [...subcategorylist];
    getItem?.map((item) => {
      updatedCategory.push(item);
    })
    setSubcategorylist(updatedCategory);
    setShowsubcategorylist(false);
  }

  const selectUnitchange = async (e, selectUnit) => {
    e.preventDefault();
    setselectUnit(selectUnit);
    setErrorvariant({
      ...errorVariant,
      unit: "",
    });
  };

  const getUnitlistforvariant = async (value, variation) => {
    let url =
      LIST_UNIT + `?service_id=${value}&lang=${props?.language?.toLowerCase()}`;
    let getUnitlist = await getRequestcall(url, props?.access_token);
    let updatedUnitlist = [];
    if (getUnitlist?.status === 200) {
      let getList = await getUnitlist.json();
      if (getList?.data?.length > 0) {
        let unit = {};
        getList?.data?.forEach((item) => {
          unit = {
            value: item.uid,
            label: item.unit,
            label_tr: item.unit_tr,
          };
          updatedUnitlist.push(unit);
        });
        setUnitlist(updatedUnitlist);
      }
    }
    if (getpid !== "add" && variation.length > 0) {
      // In edit
      editSelectedvariantunitlist(updatedUnitlist, variation);
    }
  };

  const editSelectedvariantunitlist = (updatedUnitlist, variation) => {
    let updatedVariantlist = [...variantlist];
    let variant = {};
    let selectedUnit = {};
    variation.forEach((item, index) => {
      let getunit = updatedUnitlist.filter(
        (unit) => unit.value === item.unit_id
      );
      selectedUnit = {
        value: item.unit_id,
        label: item.unit,
        label_tr: getunit[0]?.label_tr,
      };
      variant = {
        vid: item.vid,
        quantity: item.quantity,
        price: item.price,
        discount: item.discount,
        stock: item.stock,
        is_stock: item.is_stock,
        editSelectedunit: selectedUnit,
        editUnitlist: updatedUnitlist,
        showunits: false
      };
      updatedVariantlist.push(variant);
    });
    setVariantlist(updatedVariantlist);
  };

  const callSubCategory = async (categoryId) => {
    let url =
      SUBCATEGORY_LIST +
      `?category=${categoryId}&lang=${props?.language?.toLowerCase()}`;
    let getsubCategorylistapiresponse = await getRequestcall(
      url,
      props?.access_token
    );
    if (getsubCategorylistapiresponse?.status === 200) {
      let res = await getsubCategorylistapiresponse.json();
      return res;
    }
  }

  const callSubcategorylist = async (subcategoryArray, categoryId) => {
    const res = await callSubCategory(categoryId);
    if (res.length === 0) {
      setShowsubcategory(false);
      setSelectsubcategory([]);
    } else {
      let subcategoryObject = {};
      let updatedsubCategorylist = [];
      res.forEach((element) => {
        subcategoryObject = {
          value: element.id,
          label: element.title,
          label_tr: element.title_in_tr,
        };
        updatedsubCategorylist.push(subcategoryObject);
      });
      setShowsubcategory(true);
      if (getpid !== "add") {
        let editsubcategoryObject = {};
        let editSubcategorylist = [];
        subcategoryArray.forEach((getitem) => {
          let getSubcategory = updatedsubCategorylist.filter(
            (item) => item.value === getitem
          );
          if (getSubcategory?.length > 0) {
            editsubcategoryObject = {
              value: getSubcategory[0]?.value,
              label: getSubcategory[0]?.label,
              label_tr: getSubcategory[0]?.label_tr,
            };
            editSubcategorylist.push(editsubcategoryObject);
          }
        });
        setSelectsubcategory(editSubcategorylist);
        // selected item
        let difference = updatedsubCategorylist.filter(ar => !editSubcategorylist.find(rm => (rm.value === ar.value)))
        setSubcategorylist(difference);
      } else {
        setSubcategorylist(updatedsubCategorylist);
      }
    }
  };

  const instockvariantChange = (e) => {
    if (e.target.id === "always") {
      setStockhide(false);
      setErrorvariant({
        ...errorVariant,
        stock: "",
      });
    } else {
      setStockhide(true);
    }
    setAddvariant({
      ...addVariant,
      is_stock: e.target.id === "always" ? "no" : "yes",
    });
  };

  const addProductvaluechange = (e) => {
    setAddproducts({
      ...addProducts,
      [e.target.name]: e.target.value,
    });
    setErrormsg({
      ...errorMsg,
      title: e.target.name === "title_in_tr" ? "" : errorMsg.title,
      title_in_tr: e.target.name === "title" ? "" : errorMsg.title_in_tr,
      description:
        e.target.name === "description_in_tr" ? "" : errorMsg.description,
      description_in_tr:
        e.target.name === "description" ? "" : errorMsg.description_in_tr,
      [e.target.name]: "",
    });
  };

  const addVariantchange = (e) => {
    switch (e.target.name) {
      case "price":
          if (e.target.value > 0 || e.target.value === "") {
            setAddvariant({
              ...addVariant,
              [e.target.name]: e.target.value,
            });
          }
          
        break;
      case "discount":
          let value = e.target.value
          if( e.target.name === "discount"){
            if(parseFloat(e.target.value) >= 0){
              if(parseFloat(addVariant.price) >= parseFloat(e.target.value)){
                value = e.target.value
              }else{
                value = addVariant.discount
              }
            }else{
              value = ""
            }
          }
        setAddvariant({
          ...addVariant,
          [e.target.name]: value,
        });
        break;
      default:
        setAddvariant({
          ...addVariant,
          [e.target.name]: e.target.value,
        });
        break;
    }
    setErrorvariant({
      ...errorVariant,
      [e.target.name]: "",
    });
  };


  const editVariantchange = (e, getIndex) => {
    let variant = {};
    let updatedCategorylist = [];
    variantlist.forEach((item, index) => {
      if (index === getIndex) {
        let stock_value = "";
        let stock = "";
        stock = e.target.name === "stock" ? e.target.value : item.stock;
        if (e?.target?.id === getIndex + "variation_always") {
          stock_value = "no";
          stock = "0";
        } else if (e?.target?.id === getIndex + "variation_limited") {
          if (item.is_stock === "no") {
            stock = "0";
          }
          stock_value = "yes";
        }
        let discount = item?.discount
        if( e.target.name === "discount"){
          if(parseFloat(e.target.value) >= 0){
            if(parseFloat(item.price) >= parseFloat(e.target.value)){
              discount = e.target.value
            }else{
              discount = item.discount
            }
          }else{
            discount = ""
          }
        }
        variant = {
          ...item,
          quantity:
            e.target.name === "quantity" ? e.target.value : item.quantity,
          price:
            e.target.name === "price"
              ? e.target.value > 0 || e.target.value === ""
                ? e.target.value
                : ""
              : item.price,
          discount:discount,
          stock: Number(stock) < 0 ? "0" : stock,
          is_stock: stock_value === "" ? item.is_stock : stock_value,
        };
        updatedCategorylist.push(variant);
      } else {
        updatedCategorylist.push(item);
      }
    });
    setVariantlist(updatedCategorylist);
  };

  const editSelectunitchange = (e, selectedUnit, getIndex) => {
   // e.preventDefault();
    let variant = {};
    console.log("Selected unit",selectedUnit)
    let updatedCategorylist = [];
    variantlist.forEach((item, index) => {
      if (index === getIndex) {
        variant = {
          ...item,
          editSelectedunit: selectedUnit,
          showunits: false
        };
        updatedCategorylist.push(variant);
      } else {
        updatedCategorylist.push(item);
      }
    });
    setVariantlist(updatedCategorylist);
  };



  const validationVariant = () => {
    let check_value = true;
    if (addVariant.quantity === "") {
      check_value = false;
      errorVariant.quantity = "pages.add_product.qty_warn";
    }
    if (addVariant.price === "") {
      check_value = false;
      errorVariant.price = "pages.add_product.price_warn";
    }
    if (selectUnit.length === 0) {
      check_value = false;
      errorVariant.unit = "pages.add_product.unites_place";
    }
    if (stockhide === true) {
      if (addVariant.stock === "") {
        check_value = false;
        errorVariant.stock = "pages.add_product.enterstock";
      }
    }
    setErrorvariant({
      quantity: errorVariant.quantity,
      price: errorVariant.price,
      unit: errorVariant.unit,
      stock: errorVariant.stock,
    });
    if (check_value === false) {
      return false;
    } else {
      return true;
    }
  };

  // Add variant to list
  const addVarianttoList = (e) => {
    e.preventDefault();
    if (validationVariant()) {
      let updatedVariantlist = [...variantlist];
      let variant = {
        vid: "",
        quantity: addVariant.quantity,
        price: addVariant.price,
        discount: addVariant.discount,
        stock:
          addVariant.stock === "" || Number(addVariant.stock) < 0
            ? "0"
            : addVariant.stock,
        is_stock: addVariant.is_stock,
        editSelectedunit: selectUnit,
        editUnitlist: unitlist,
        showunits: false,
      };
      updatedVariantlist.push(variant);
      setVariantlist(updatedVariantlist);
      setAddvariant({
        quantity: "",
        price: "",
        stock: "",
        is_stock: "yes",
        discount: ""
      });
      setStockhide(true);
      setShowAddVariation(false);
    }
  };

  const productDelete = (e, item) => {
    e.preventDefault();
    setDeleteinfo({
      ...deleteInfo,
      name: item.title,
      id: item,
    });
    setDeleteModal(true);
  };

  const itemDelete = async () => {
    deleteVariantfromlist(deleteInfo?.id);
    setDeleteModal(false);
  };

  // Delete variant from list
  const deleteVariantfromlist = (getindex) => {
    const updateVariantlist = variantlist.filter(
      (item, index) => index !== getindex
    );
    setVariantlist(updateVariantlist);
  };

  const validation = () => {
    let checkValue = true;
    if (variantlist.length > 0) {
      if (!validationVariantlist()) {
        checkValue = false;
      } else {
        checkValue = true;
      }
    }
    if (addProducts.title === "" && addProducts.title_in_tr === "") {
      if (props.language === "Tr") {
        errorMsg.title_in_tr = "pages.add_product.pname_warn";
      } else {
        errorMsg.title = "pages.add_product.pname_warn";
      }
      checkValue = false;
    }
    if (
      addProducts.description === "" &&
      addProducts.description_in_tr === ""
    ) {
      if (props.language === "Tr") {
        errorMsg.description_in_tr = "pages.add_product.description_warn";
      } else {
        errorMsg.description = "pages.add_product.description_warn";
      }
      checkValue = false;
    }
    if (addProducts.description_in_tr !== "") {
      if (addProducts?.description_in_tr?.length < 10) {
        errorMsg.description_in_tr = "pages.add_product.description_valid";
        checkValue = false;
      }
    }
    if (addProducts.description !== "") {
      if (addProducts?.description?.length < 10) {
        errorMsg.description = "pages.add_product.description_valid";
        checkValue = false;
      }
    }
    if (selectcategory?.length === 0) {
      errorMsg.select_category = "pages.add_product.category_warn";
      checkValue = false;
    }
    if (showsubcategory === true) {
      if (selectsubcategory.length === 0) {
        errorMsg.select_sub_category = "pages.add_product.subcategory_warn";
        checkValue = false;
      }
    }

    if (variantlist.length === 0) {
      if (validationVariant() === false) {
        checkValue = false;
      }
    }

    if (variantlist.length === 0) {
      toast.error(t("pages.add_product.variation_toast"));
      checkValue = false;
    }

    if (imageName.length === 0) {
      errorMsg.images = "pages.add_product.file_warn";
      checkValue = false;
    }

    if (selectedTax?.length === 0) {
      errorMsg.select_vat = "pages.Select vat";
      checkValue = false;
    }

    setErrormsg({
      title: errorMsg.title,
      title_in_tr: errorMsg.title_in_tr,
      description: errorMsg.description,
      description_in_tr: errorMsg.description_in_tr,
      select_category: errorMsg.select_category,
      select_sub_category: errorMsg.select_sub_category,
      images: errorMsg.images,
      select_vat: errorMsg.select_vat,
    });

    if (checkValue === false) {
      return false;
    } else {
      return true;
    }
  };

  const validationVariantlist = () => {
    let getList = variantlist.map((item, index) => checkValueempty(index));
    let checkValue = getList.filter((item) => item === false);
    if (checkValue.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const checkValueempty = (index) => {
    let check_value = true;
    let getValue = variantlist[index];
    let errorText = "";
    if (getValue?.quantity === "") {
      check_value = false;
      errorText = "pages.add_product.qty_warn";
    }
    if (getValue?.price === "") {
      check_value = false;
      errorText = "pages.add_product.price_warn";
    }
    if (getValue?.is_stock === "yes") {
      if (getValue?.stock === 0) {
        check_value = false;
        errorText = "pages.add_product.enterstock";
      }
    }
    if (check_value === true) {
      return true;
    } else {
      toast.error(t(errorText));
      return false;
    }
  };

  const closeCurrentimage = (id) => {
    const updateImagenameArray = imageName.filter(
      (item, index) => index !== id
    );
    setImagename(updateImagenameArray);
  };

  const validPublishProducts = () => {
    if (showAddVariation === true) {
      return validationVariant();
    } else {
      return true;
    }
  };

  const publishProduct = async (e) => {
    e.preventDefault();
    if (validation() && validPublishProducts()) {
      let sub_service_id = selectsubcategory?.map((e) => e.value).join(",");
      let id = "";
      if (getpid !== "add") {
        id = addProducts.id;
      } else {
        id = "";
      }
      let getImagename = [];
      let getImages = "";
      if (imageName?.length > 0) {
        imageName.forEach((item) => {
          getImagename.push(item?.fileName);
        });
        getImages = getImagename.join(",");
      }
      // Get product variant from variant list
      let getVariant = {};
      let updatedVariantlist = [];
      variantlist.forEach((item) => {
        getVariant = {
          vid: item?.vid,
          is_stock: item?.is_stock,
          price: item?.price,
          quantity: item?.quantity,
          stock: item?.stock,
          unit_id: item?.editSelectedunit.value,
          discount:
            item?.discount === null || item?.discount === ""
              ? 0
              : item?.discount,
        };
        updatedVariantlist.push(getVariant);
      });
      let productdata = {
        title:
          addProducts.title === ""
            ? addProducts.title_in_tr
            : addProducts.title,
        title_in_tr:
          addProducts.title_in_tr === ""
            ? addProducts.title
            : addProducts.title_in_tr,
        description:
          addProducts.description === ""
            ? addProducts.description_in_tr
            : addProducts.description,
        description_in_tr:
          addProducts.description_in_tr === ""
            ? addProducts.description
            : addProducts.description_in_tr,
        id: id,
        service_id: addProducts.service_id,
        store_id: props.storeDetail.store_id,
        images: getImages,
        sub_service_id: sub_service_id,
        variation: updatedVariantlist,
        vat_id: selectedTax.value,
        sku: addProducts?.sku,
      };
      let getResponse = await postRequestcall(
        ADD_PRODUCT,
        props.access_token,
        productdata
      );
      if (getResponse?.status === 200) {
        if (getpid !== "add") {
          toast.success(t("pages.your product adding request is waitng for admin approve!"));
        } else {
          toast.success(t("pages.your product adding request is waitng for admin approve!"));
        }
        navigate("/vendor/products");
      }
      else if (getResponse?.status === 400) {
        let getError = await getResponse?.json();
        if(getError?.error?.is_deleted) {
          props?.clearStoredetail([]);
          props.logindata.type = "user";
          props.fetchLogindata(props.logindata);
          let getError = await getResponse.json();
          toast.error(getError?.errors);
          navigate("/vendor/");
        } else {
          toast.error(getError?.errors);
        }
      }
    }
  };

  const cancelProduct = (e) => {
    e.preventDefault();
    navigate("/vendor/products");
  };

  const helpInfo = () => {
    setShowModal(true);
  };

  const onSelectVat = async (e, selectedVat, index) => {
    e.preventDefault();
    setSelectedTax(selectedVat);
    setShowvatlist(false);
  };

  const showSubmanualpopup = (e) => {
    e.preventDefault();
    if (addProducts.service_id !== "") {
      setShowsubmanual(true);
    } else {
      toast.error(t("pages.add_product.select_category"));
    }
  };

  const categoryListrender = (categories) => {
    let updatedCategorylist = [];
    categories.forEach((item, index) => {
      let categoryObject = {};
      const data = props?.categories?.filter(
        (category) => category?.id === item.value
      );
      categoryObject = {
        value: data[0]?.id,
        label: data[0]?.title,
      };
      updatedCategorylist.push(categoryObject);
    });
    return updatedCategorylist;
  };

  const selectedCategoryrender = (selectcategory) => {
    if (selectcategory?.length !== 0 && typeof selectcategory !== "undefined") {
      const getCategory = props?.categories?.filter(
        (category) => category?.id === selectcategory.value
      );
      console.log("getcategory", getCategory)
      if (getCategory?.length > 0) {
        selectcategory = {
          value: getCategory[0]?.id,
          label: getCategory[0]?.title,
        };
        return selectcategory?.label;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const subcategryListrender = (subcategories) => {
    let updatedCategorylist = [];
    let categoryObject = {};
    subcategories.forEach((item) => {
      categoryObject = {
        value: item?.value,
        label: props.language === "Tr" ? item.label_tr : item.label,
        label_tr: item.label_tr,
      };
      updatedCategorylist.push(categoryObject);
    });
    return updatedCategorylist;
  };

  const selectedSubcategrylistrender = (selectsubcategory) => {
    let updatelist = [];
    if (selectsubcategory?.length !== 0) {
      let subCategoryobject = {};
      selectsubcategory.forEach((item) => {
        subCategoryobject = {
          value: item?.value,
          label: props?.language === "Tr" ? item?.label_tr : item?.label,
          label_tr: item?.label_tr,
        };
        updatelist.push(subCategoryobject);
      });
      return updatelist;
    } else {
      return updatelist;
    }
  };

  const selectedTaxrender = (item) => {
    const getTax = taxarray.filter(
      (tax) => tax?.value === item.value
    );
    if (getTax?.length > 0) {
      return getTax[0]?.label;
    };
  }

  const storeFiles = (getImage, type) => {
    let imagevalue = [...imageName];
    imagevalue.push(getImage);
    setImagename(imagevalue);
  };


  const unitListopen = (e, getIndex) => {
    e.preventDefault();
    if (variantlist[getIndex].showunits) {
      let array = [...variantlist]
      array[getIndex].showunits = false;
      setVariantlist(array);
    } else {
      let array = [...variantlist]
      array[getIndex].showunits = true;
      setVariantlist(array);
    }
  }

  const unitListclose = () => {
    let array = [...variantlist];
    array = array.map((item)=>{ return { ...item, showunits:false } });
    setVariantlist(array);
  }

  const clearSelected = () => {

  }

  return (
    <div className="col-xl-9 main-content add-product">
      <div className="card">
        <div className="card-body">
          <h5 className="header-title mb-3">{t("pages.add_product.title")}</h5>
          <Form>
            <Row>
              <Col sm={6} md={6} lg={6} xl={6} className="pb-4">
                <FormgroupPage label={t("pages.add_product.pname") + " " + t("pages.In English")}
                  placeholder={t("pages.add_product.pname_place")} value={
                    addProducts.title.charAt(0).toUpperCase() +
                    addProducts.title.slice(1)
                  } name={"title"} onChange={addProductvaluechange} error={t(errorMsg.title)} />
              </Col>
              <Col sm={6} md={6} lg={6} xl={6} className="pb-4">
                <FormgroupPage label={t("pages.add_product.pname") + " " + t("pages.In Turkish")}
                  placeholder={t("pages.add_product.pname_place")} value={addProducts.title_in_tr.charAt(0).toUpperCase() + addProducts.title_in_tr.slice(1)
                  } name={"title_in_tr"} onChange={addProductvaluechange} error={t(errorMsg.title_in_tr)} />
              </Col>
              <Col
                sm={12} md={12} lg={12} xl={12}
                style={{ textAlign: "end" }}
              >
                <button
                  className="primary-btn"
                  onClick={(e) => showSubmanualpopup(e)}
                >
                  + {t("pages.add_product.addmanual_subcategory")}
                </button>
              </Col>
              <Col sm={12} md={12} lg={6} xl={6} className="pb-4 position-relative">
                <FormLabel label={t("pages.add_product.category")} />
                <SingleselectPage
                  groupItemClick={selectCategorychange}
                  list={categoryListrender(categorylist)}
                  setShowList={setShowList}
                  showList={showList}
                  placeholder={t("pages.add_product.category_place")}
                  value={selectedCategoryrender(selectcategory)}
                  clearSelected={clearSelected}
                  inputClassname={"product-category"}
                />
                <span className="text-danger">
                  {t(errorMsg.select_category)}
                </span>
              </Col>
              <Col sm={12} md={12} lg={6} xl={6} className="pb-4 position-relative">
                {showsubcategory && (
                  <>
                    <FormLabel label={t("pages.add_product.subcategoty")} />
                    <MultiselectPage
                      remove={removesubCategory}
                      list={subcategryListrender(subcategorylist)}
                      setShowList={setShowsubcategorylist}
                      showList={showsubCategorylist}
                      sublist={selectedSubcategrylistrender(selectsubcategory)}
                      placeholder={t("pages.add_product.subcategory_place")}
                      clearSelected={clearSelectedsubcategory}
                      groupItemClick={selectsubCategorychange}
                    />
                    <div className="text-danger">
                      {t(errorMsg.select_sub_category)}
                    </div>
                  </>
                )}
              </Col>
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="stock-selection">
                  <h5 className="">{t("pages.add_product.variation")}</h5>
                  <div className="help-info" onClick={() => helpInfo()}>
                    <img
                      src={information}
                      title={t("pages.Help")}
                      height="25"
                      width="25"
                      alt="help"
                    />
                    <span>{t("pages.Help")}</span>
                  </div>
                </div>
              </div>
              {variantlist.map((item, index) => (
                <div>
                  <VariationboxPage
                    addVariantchange={(e) => editVariantchange(e, index)}
                    addVariant={item}
                    setShowAddVariation={setShowAddVariation}
                    unitlist={item.editUnitlist}
                    selectUnit={item.editSelectedunit}
                    selectUnitchange={editSelectunitchange}
                    stockhide={item.is_stock}
                    list={true}
                    productDelete={(e) => productDelete(e, index)}
                    instockvariantChange={(e) => editVariantchange(e, index)}
                    index={index}
                    type={"unit_list"}
                    unitListopen={unitListopen}
                    unitListclose={unitListclose}
                    showunits={item?.showunits}
                  />
                </div>
              ))}
              {showAddVariation === false && (
                <div className="mb-3 text-end">
                  <button
                    onClick={() => setShowAddVariation(true)}
                    className="btn-submit  py-1"
                  >
                    {t("pages.add_product.add_variant")}
                  </button>
                </div>
              )}
              <div>
                {showAddVariation === true && (
                  <VariationboxPage
                    addVariantchange={(e) => addVariantchange(e)}
                    addVariant={addVariant}
                    setShowAddVariation={setShowAddVariation}
                    unitlist={unitlist}
                    selectUnit={selectUnit}
                    addVarianttoList={addVarianttoList}
                    selectUnitchange={selectUnitchange}
                    stockhide={stockhide}
                    errorVariant={errorVariant}
                    instockvariantChange={instockvariantChange}
                    list={false}
                    setShowcategorylist={setShowunits}
                    showCategorylist={showunits}
                  />
                )}
              </div>
              <Col sm={12} md={12} lg={12} xl={6} className="pb-4 position-relative">
                <FormLabel label={t("pages.add_product.tax")} />
                <SingleselectPage
                  groupItemClick={onSelectVat}
                  list={taxarray}
                  setShowList={setShowvatlist}
                  showList={showvatlist}
                  placeholder={""}
                  value={selectedTaxrender(selectedTax)}
                  clearSelected={clearSelected}
                  inputClassname={"tax-list"}
                />
              </Col>
              <Col sm={12} md={12} lg={6} xl={6} className="pb-4">
                <FormgroupPage label={t("pages.add_product.sku")} placeholder={t("pages.add_product.sku_place")} value={addProducts.sku} name={"sku"} require={false} onChange={addProductvaluechange} />
              </Col>
              <Col sm={12} md={12} lg={6} xl={6} className="pb-4">
                <FormgroupPage as={"textarea"} style={{ height: "auto" }} rows={6} label={t("pages.add_product.description") + " " + t("pages.In English")} placeholder={t("pages.add_product.description_place")} value={addProducts.description.charAt(0).toUpperCase() +
                  addProducts.description.slice(1)} name={"description"} onChange={addProductvaluechange}
                  error={t(errorMsg.description)} />
              </Col>
              <Col sm={12} md={12} lg={6} xl={6} className="pb-4">
                <FormgroupPage as={"textarea"} style={{ height: "auto" }} rows={6} label={t("pages.add_product.description_place") + " " + t("pages.In Turkish")} placeholder={t("pages.add_product.description_place")} value={addProducts.description_in_tr.charAt(0).toUpperCase() + addProducts.description_in_tr.slice(1)} name={"description_in_tr"} onChange={addProductvaluechange}
                  error={t(errorMsg.description_in_tr)} />
              </Col>
              <Col sm={12} md={12} lg={12} xl={12} className="pb-4  upload-profiles">
                <FormLabel label={t("pages.add_product.product_upload")} />
                <div className="multi-upload-img">
                  <UploadfilesPage storeFiles={storeFiles} type={"add-product"} />
                  <div className="text-danger" style={{ whiteSpace: "nowrap" }}>
                    {imageName.length === 0 ? t(errorMsg.images) : ""}
                  </div>
                </div>
                {imageName?.map((item, index) => (
                  <div
                    className="multi-upload-img"
                    style={{ marginBottom: "20px" }}
                  >
                    <img
                      src={close_cross}
                      className="close-icon"
                      onClick={() => closeCurrentimage(index)}
                      alt="close"
                    ></img>
                    <LazyLoadImage
                      src={item?.preview_url}
                      onError={(e) => {
                        e.target.src = upload_img;
                      }}
                      className="product-img"
                      alt=""
                    ></LazyLoadImage>
                  </div>
                ))}
              </Col>
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12  text-end">
                <button
                  className="cancel-btn"
                  onClick={(e) => cancelProduct(e)}
                >
                  {t("pages.cancel")}
                </button>
                <button
                  className="add-product ms-4"
                  onClick={(e) => publishProduct(e)}
                >
                  {/* {getpid !== "add"?t("pages.save"):t("pages.add_product.submit")} */}
                  {t("pages.add_product.submit")}
                </button>
              </div>
            </Row>
          </Form>
        </div>
      </div>
      {showModal && (
        <HelpPage setShowModal={setShowModal} showModal={showModal} />
      )}
      {showSubmanual && (
        <Subcategorymanual
          showSubmanual={showSubmanual}
          setShowsubmanual={setShowsubmanual}
          addProducts={addProducts}
        />
      )}
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={itemDelete}
        ></DeletepopupPage>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  language: state?.languageState?.language,
  
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps, { fetchHeaderContent, clearStoredetail, fetchLogindata })(AddproductPage);
